import Repository from '../../Repository';

const resource = '/return-authorizations';

export default {
  createReturnAuthorization(payload) {
    return Repository.post(`${resource}`, payload);
  }
}
